import { render, staticRenderFns } from "./pop-field-history.vue?vue&type=template&id=5c06fc06"
import script from "./pop-field-history.vue?vue&type=script&lang=ts"
export * from "./pop-field-history.vue?vue&type=script&lang=ts"
import style0 from "./pop-field-history.vue?vue&type=style&index=0&id=5c06fc06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports